<style src="./style.scss">
</style>

<script lang="ts">
  import Modal from "@components/modal";
  import Button from "@components/button";
  import TextInput from "@components/textInput";

  export let isOpen = false;
  export let onClose = () => null;
  export let onSubmit = () => null;
  export let phone: string = "";

  let phoneMask = "00 0 0000-0000";
</script>

<Modal isOpen="{isOpen}" title="Mudar telefone" onClose="{onClose}">
  <form on:submit|preventDefault="{() => onSubmit(phone)}">
    <TextInput
      placeholder="Digite seu celular"
      bind:mask="{phoneMask}"
      type="tel"
      isPhone="{true}"
      bind:value="{phone}" />

    <Button
      title="Salvar"
      onClick="{() => onSubmit(phone)}"
      disabled="{phone.length !== 11}" />
  </form>
</Modal>
